import React from 'react';
import { Box, Stack } from '@metarouter-private/mr-mui';
import PipelineEventSplitButton from './PipelineEventSplitButton';
import PipelineFiltersButton from './PipelineFiltersButton';
import PipelineTransformsButton from './PipelineTransformsButton';

export default function PipelineTransformationsButtons() {
  return (
    <Stack direction="row" spacing={1}>
      <Box>
        <PipelineFiltersButton />
      </Box>
      <Box>
        <PipelineTransformsButton />
      </Box>
      <Box>
        <PipelineEventSplitButton />
      </Box>
    </Stack>
  );
}
